<template>
<div>
  <transition name="ani-slide-in">
    <emergency-numbers-component></emergency-numbers-component>
  </transition>
</div>
</template>

<script>
import EmergencyNumbersComponent from "@/components/misc/EmergencyNumbers/EmergencyNumbersComponent";
export default {
name: "EmergencyNumbers",
  components: {EmergencyNumbersComponent},
}
</script>

<style scoped>

</style>